var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldMultiSelect',{attrs:{"label":_vm.label,"state":_vm.state,"disabled":_vm.disabled,"is-required":_vm.isRequired,"class-label":_vm.classLabel,"option-description":"prefix","placeholder":_vm.placeholder,"load-options":_vm.loadOptions},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }